import React, { useState, useEffect } from "react";
import "./SubFilter.css";
import BackBtn from "../../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../../../Components/BottomBar/BottomBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../../../ApiContext";
import Loading from "../../../../Components/Loading/Loading";

export default function SubFilter() {
  const navigate = useNavigate();
  const baseUrl = useBaseUrl();
  const location = useLocation();
  const { categorySlug, attributeSlug } = location.state || {};
  const { userToken } = useAuth();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [attributeValues, setAttributeValues] = useState([]);
  const [attrString, setAttrString] = useState("");
  const [priceAttrString, setPriceAttrString] = useState("");
  const [subFilterSlug, setSubFilterSlug] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  useEffect(() => {
    const fetchSubAttribute = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${categorySlug}/attribute-values?slugs=${attributeSlug}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setAttributeValues(response.data.attributes[0].values);
        setSubFilterSlug(response.data.attributes[0].slug);
        setIsLoading(false);
      } catch (error) {
        console.log(
          "Error during getting sub filter product attributes",
          error
        );
      }
    };
    if (userToken) {
      fetchSubAttribute();
    }
  }, [baseUrl, userToken]);

  const checkValueHandler = (value) => {
    setAttrString((prevState) => {
      const newAttr = `(${subFilterSlug},${value})`;
      if (prevState.includes(newAttr)) {
        const updatedAttrString = prevState.replace(
          new RegExp(`\\(${subFilterSlug},${value}\\),?`),
          ""
        );
        const cleanedAttrString = updatedAttrString.replace(/,$/, "");
        if (cleanedAttrString === "") {
          localStorage.removeItem("attribute filters");
        } else {
          localStorage.setItem("attribute filters", cleanedAttrString);
        }
        return cleanedAttrString;
      } else {
        const newAttrString = `${prevState}${prevState && ","}${newAttr}`;
        localStorage.setItem("attribute filters", newAttrString);
        return newAttrString;
      }
    });
  };

  useEffect(() => {
    const storedAttrStringJSON = localStorage.getItem("attribute filters");
    const storedPriceStringJSON = localStorage.getItem("price filters");
    if (storedAttrStringJSON) {
      setAttrString(storedAttrStringJSON);
    }
    if (storedPriceStringJSON) {
      setPriceAttrString(storedPriceStringJSON);
    }
  }, []);

  const handleshowProducts = async () => {
    if (attrString || priceAttrString) {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/digikala/${categorySlug}/product-varients?attributes=${priceAttrString}${
            attrString && priceAttrString && `,`
          }${attrString}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        navigate("/partialProducts", {
          state: {
            categorySlug,
            filteredProducts: response.data.products,
          },
        });
      } catch (error) {
        console.log("Error during getting filtered products", error);
      }
    } else {
      navigate("/partialProducts", {
        state: { categorySlug, filteredProducts: null },
      });
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle partialProductsHeading">زیرمجموعه فیلتر</h3>
          <div className="subFilterWrapper centeredFlex">
            {isLoading ? (
              <Loading />
            ) : (
              <div className="subFilterValues centeredFlex  scroll">
                {attributeValues &&
                  attributeValues.length > 0 &&
                  attributeValues.map((value) => (
                    <div
                      key={value}
                      className=" subFilterValue centeredFlex horizontalBorder"
                      onClick={() => checkValueHandler(value)}
                    >
                      <label htmlFor="selectedValue">{value}</label>
                      <input
                        type="checkbox"
                        id="selectedValue"
                        checked={attrString.includes(value)}
                        onChange={() => {
                          console.log("value changed");
                        }}
                      />
                    </div>
                  ))}
              </div>
            )}
            <div className="subFilterBtnWrapper">
              <button
                type="button"
                className="nextQuestion showSubFilteredProducts"
                onClick={handleshowProducts}
              >
                مشاهده محصولات
              </button>
            </div>
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
